// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.single-privacy h3[data-v-22d65108]\n{\n    margin-bottom:15px;\n}\n.single-privacy[data-v-22d65108]{\n    margin-bottom: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
